module.exports = __webpack_public_path__ + "img/20250827_Laurenz-21.813b3a7e.jpg";